export default __webpack_public_path__ + "static/media/bachelors.da1ea734.svg";